{ "imageTag": "20261105063128_4cfea84", "buildUri": "vstfs:///Build/Build/104259", "buildId": "104259", "sourceCommit": "4cfea8428b3960218707cd8a89b9b3a1ced59b0a", "sourceBranch": "main", "releaseDate": "2026-11-05T06:34:59Z" }
